import { render, staticRenderFns } from "./ModalRetrieveFileTypes.vue?vue&type=template&id=56f9d91a"
import script from "./ModalRetrieveFileTypes.vue?vue&type=script&lang=js"
export * from "./ModalRetrieveFileTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports